/* This example requires Tailwind CSS v2.0+ */
import { ExternalLinkIcon } from '@heroicons/react/solid'

import donation from '../../../../images/donation.jpg'

export default function Example() {
  return (
    <div className="relative bg-gray-800">
      <div className="h-56 bg-indigo-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
        <img
          className="w-full h-full object-cover"
          src={donation}
          alt=""
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="md:ml-auto md:w-1/2 md:pl-10">
          <h2 className="text-base font-semibold uppercase tracking-wider text-gray-300">Soutenir notre cause</h2>
          <p className="mt-2 text-white text-3xl font-extrabold tracking-tight sm:text-4xl" data-aos="fade-right">Pourquoi nous soutenir?</p>
          <p className="mt-3 text-lg text-gray-300" data-aos="fade-right"> 
            Ce projet est à l'initiative de Marie France Bomengo infirmière à Bruxelles.
          </p>
          <p className="mt-3 text-lg text-gray-300" data-aos="fade-right">
            Apres avoir constaté que les enfants sont délaissés dans les différents coins de la RDC, 
            elle a mis en place l’Association sans but lucratif appelé « infirmières des voies publiques » pour promouvoir 
            la santé des enfants démunis en leur apportant des soins de premières nécessités gratuitement.
          </p>
          <p className="mt-3 text-lg text-gray-300" data-aos="fade-right">
            la santé des enfants démunis en leur apportant des soins de premières nécessités gratuitement.
          </p>
          {/* <div className="mt-8">
            <div className="inline-flex rounded-md shadow">
              <a
                href="#"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50"
              >
                Visit the help center
                <ExternalLinkIcon className="-mr-1 ml-3 h-5 w-5 text-gray-400" aria-hidden="true" />
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}
